module.exports = __webpack_public_path__ + "static/media/web_buttons_dollabills.b0c09fbf.svg";